/**
 * Route loaders (lane BOO1): every route that reads data names its reads in its loader, so the router's
 * `defaultPreload: 'intent'` fetches them on hover or touch, and a navigation starts all of them at once instead of
 * one component after another. The loaders call `queryClient.ensureQueryData` with the same query options the
 * pages' hooks use (one cache entry each) and never wait for the answers: a page renders at once with its own
 * skeleton, error and empty states, exactly as before, and finds its data in the cache when it is there.
 */
import type { QueryClient } from '@tanstack/react-query'
import type { Me } from '@algoboo/schema/api'
import { meQuery } from './api'

/** Start the reads and let them run: a failed read is the page's to show (its query holds the error), never the loader's. */
export function prefetch(...reads: (Promise<unknown> | null | undefined | false)[]): void {
  for (const r of reads) if (r) r.catch(() => undefined)
}

/**
 * Reads that need the viewer: run once the session is known (at once when it is cached, else after `GET /me`, which
 * the session provider asks for anyway), and only for someone signed in.
 */
export function prefetchSignedIn(qc: QueryClient, reads: (me: Me) => (Promise<unknown> | null | undefined | false)[]): void {
  prefetch(
    qc.ensureQueryData(meQuery()).then((me) => {
      if (me) prefetch(...reads(me))
    }),
  )
}
